import React, {useEffect, useState} from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Axios from 'axios';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import MenuIcon from '@material-ui/icons/Menu';

import InfoIcon from '@material-ui/icons/Info';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

import mainListItems from './listItems';
//import Chart from './Chart';
//import Deposits from './Deposits';
import { isAdmin } from '../../utils/Permission';
import { Switch, Route, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import KopaProLicense from './KopaProLicense';
import Domains from './Domains';
import Stat from './Stat';
import LicenseEditForm from '../LicenseEdit/LicenseEditForm';
import DomainsEditForm from '../DomainsEdit/DomainsEditForm';
import Account from './Account';

import LangChangeSelect from '../../component/LangChangeSelect';
import Countdown from "../../component/Countdown";
import {MyMess, store, history} from '../../App'
import MerchantList from './MerchantList';
import MerchantEditForm from '../MerchantEdit/MerchantEditForm';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import { loggoutSuccess } from '../../redux/ducks/userDuck';
import { readMerchant } from '../../redux/ducks/merchant';
import { asyncLogout } from '../../redux/ducks/userDuck';
import welcomeImage from '../../images/Welcome.png'
import { GetLicensesStat, openDirectLogin } from '../../server/WebServiceUrl';
import moment from 'moment';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://kopapro.com/">
        {MyMess.companyName}
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  langPicker:{
    color:'white',
  },
  messages: {
    minWidth: 600,
    maxWidth: 600,
  },
  cardBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 20
  },
  welcomeImg:{
    width: '100%',
    textAlign: 'center'
  }
}));

export default function Dashboard(props) {
  const { pathname } = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();
  let user = useSelector(state => (state.user))
  let merchant = useSelector(state => (state.merchant))
  const [stat, setStat] = useState({});

  useEffect(() => {
    if(user.email && user.type === 'merchant') {
      dispatch(readMerchant(user.email));
    } else if(isAdmin(user.type)){
      getStatData()
    }
  }, [user.email]);

  const [open, setOpen] = React.useState(true);
  const [trialSiteState, setTrialSiteState] = useState({
    loading:false
  })

  let { path, url } = useRouteMatch();
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    dispatch(asyncLogout());
  }

  //const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  
  let app = useSelector(state => state.app);
  MyMess.setLanguage(app.lang);
  
  const logoutButtonHandler = (e) => {    
    store.dispatch(loggoutSuccess());
    history.push('/login');
    GlobalSnackBarUtil.open({
        message:MyMess.loggoutSuccess
    });
  }

  const getStatData =async () => {
    let res = await Axios.get(GetLicensesStat);
    console.log(res.data);
    if(res && res.status === 200 && res.data && res.data.pass){
      setStat(res.data.statistics)
    }else{
      GlobalSnackBarUtil.open({
        message:MyMess.refreshFail,
        severity:'error'
      })
    }
  }

  const showStat = () => {
    if(isAdmin(user.type)) {
      console.log(stat)

      return <Container maxWidth={false} style={{
        paddingTop: 16,
      }} >
         <Grid  container spacing={3}>
          <Grid item lg={3} sm={6} xl={3} xs={12}>
              <Stat plan="su" data={stat.su}/>
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={12}>
              <Stat  plan="bu" data={stat.bu}/>
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={12}>
              <Stat plan="pm" data={stat.pm}/>
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={12}>
            <Stat plan="et" data={stat.et}/>
          </Grid>
         </Grid>
      </Container>
    }
  }

  const showInfoMessage = () => {
    // merchant info not loaded
    if (merchant.email == "") {
      return null;
    }

    const requiredFields = ["compName", "addr", "addr2", "zipCodeStr", "countryISO",
      "compCountryCode", "compTel", "firstName", "lastName", "countryCode", "tel"
    ];
    let isFilled = true;

    for (let index = 0; index < requiredFields.length; index++) {
      const key = requiredFields[index];
      if (!merchant[key]) {
        isFilled = false;
        break;
      }
    }

    if (!isFilled) {
      return (
        <div className={classes.cardBox}>
          <Card className={classes.messages}>
              <CardHeader 
                avatar={<InfoIcon />}
              title={
                <Typography color="theme.textSecondary"  variant="h5" component="h5" >
                   {MyMess.dashboard.missingInfo.title}
                </Typography>
              } />
              <CardContent>
                <Typography variant="body2" color="textPrimary" component="p">
                {MyMess.dashboard.missingInfo.notCompletedMsg}
                {MyMess.dashboard.missingInfo.notCompletedMsg2}
                </Typography>
              </CardContent>
            <CardActions>
              <Button variant="contained" color="primary" onClick={e => {history.push('/main/account')}}>
                {MyMess.dashboard.missingInfo.action}
              </Button>
            </CardActions>
          </Card>
        </div>
      )
    }
    

  }

  const showTrialMessage = () => {

    // merchant info not loaded
    if (merchant.email == "") {
      return null;
    }  

    const openSiteHanler = () => {
      setTrialSiteState({
        loading:true
      })
      const startNnlVisit = async () => {        
        openDirectLogin(merchant.trialCode);  
        setTrialSiteState({
          loading:false
        })
      }

      startNnlVisit();
      
    }

    const getTrialLic = () => {
      let trialLic = null;
      if(merchant.shoplicenses){
         merchant.shoplicenses.forEach((lic, i) => {
           if(lic && lic.isTrial && lic.code === merchant.trialCode){
             trialLic = lic;            
           }
         })
       }

       return trialLic;
    }

    const isTrialExpired = () => {
      let trialLic = getTrialLic();

      if(trialLic){
        return trialLic.status === 'expired';
      }

      return false;

    }

    const isTrialExtended = () => {
      let trialLic = getTrialLic();

      if(trialLic){
        return trialLic.trialExtended
      }

      return false;
    }

    const isPaidLicenseExist = () => {
      let result = false;
      if(merchant.shoplicenses){

         merchant.shoplicenses.forEach((lic, i) => {
           if(lic && lic.licensePayments){
              for(let index in lic.licensePayments) {
                const payment = lic.licensePayments[index];
                if (payment.amt > 0 && payment.status === 'paid') {
                  result = true;
                }
              }
                        
           }
         })
       }
       return result;
    
    }

    const trialTitle = () =>{
      const trialLic = getTrialLic();

      if(isTrialExpired()){
          return MyMess.kopaproLicense.trialExpired;
                   
      }else{
          if (trialLic && merchant.trialCreated) {
            return MyMess.dashboard.trialPeriod.title;
          }
          return MyMess.dashboard.addTrial.title;
                
      }
    }

    const trialLic = getTrialLic();
    if(!trialLic && isPaidLicenseExist()) {
      return null;
    }


    let countDownFooterMessage = "";
    if (trialLic) {
      countDownFooterMessage = `${MyMess.dashboard.trialPeriod.expireAt} ${moment.unix(moment(trialLic.expDate).format('X')).format('YYYY-MM-DD hh:mm A')}`;
    }

    return (
      <div className={classes.cardBox}>
        <Card className={classes.messages}>
            <CardHeader 
              avatar={<InfoIcon />}
            title={
              <Typography color="theme.textSecondary"  variant="h5" component="h5" >
                  {trialTitle()}
              </Typography>
              
            } />
            <CardContent>
              { merchant.trialCreated && !isTrialExpired() && trialLic &&
                <Countdown endDate={trialLic.expDate} footerMessage={countDownFooterMessage} />
              }
              <Typography variant="body2" color="textPrimary" component="p">
              {MyMess.dashboard.addTrial.msg}           
              </Typography>
              <Typography variant="body2" color="textPrimary" component="p">
              {MyMess.dashboard.addTrial.msg2}           
              </Typography>
            </CardContent>
            { !merchant.trialCreated && 
            <CardActions>          
              <Button variant="contained" color="primary" onClick={e => {history.push('/main/kopapro/trial')}}>
                {MyMess.dashboard.addTrial.action1}
              </Button>
              <Button variant="contained" color="primary" onClick={e => {history.push('/main/kopapro/create')}}>
                {MyMess.dashboard.addTrial.action2}
              </Button>           
            </CardActions> 
            }

            { merchant.trialCreated && !isTrialExpired() &&
            <CardActions>          
              <Button variant="contained" color="primary" onClick={openSiteHanler}>
                {!trialSiteState.loading && MyMess.dashboard.addTrial.action3}
                {trialSiteState.loading && "Loading..."}
              </Button>                         
              
              <Button variant="contained" color="primary" onClick={e => {history.push('/main/kopapro/extend/' + merchant.trialCode)}}>
                {MyMess.dashboard.addTrial.action2}
              </Button>           
            </CardActions> 
            }

          { merchant.trialCreated && isTrialExpired() &&
            <CardActions>                              
              { !isTrialExtended() && 
              <Button variant="contained" color="primary" onClick={e => {history.push('/main/kopapro/extend/' + merchant.trialCode)}}>
                {MyMess.kopaproLicense.extendTrial}
              </Button>           
              }
              <Button variant="contained" color="primary" onClick={e => {history.push('/main/kopapro/extend/' + merchant.trialCode)}}>
                {MyMess.dashboard.addTrial.action2}
              </Button>           
            </CardActions> 
            }
        </Card>
      </div>
    )
    
    

  }

  return (
    
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
          >
            <MenuIcon />
          </IconButton>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            {MyMess.goodDay}, {merchant.firstName} {merchant.lastName} ({user.email}) 
          </Typography>
          
          {/* <IconButton color="inherit">
            <Badge badgeContent={4} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
          <Tooltip title={MyMess.general.account}>
            <IconButton aria-label="account"  color="inherit" onClick={e => {history.push('/main/account')}}>
              <AccountCircle />
            </IconButton>
          </Tooltip>
          <LangChangeSelect className={classes.langPicker}/>
          <Tooltip title={MyMess.general.logout}>
            <IconButton aria-label="logout"  color="inherit" onClick={handleLogout} >
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>{mainListItems(path, url, user.type, user.scopes)}</List>
        <Divider />
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>  
            <Switch>
                {/* <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} /> */}
                <Route exact path="/main">
                  {/* show alert here */}
                  <Box className={classes.welcomeImg} mb={5} >
                    <Typography  variant="h5" component="h5"  >
                    {MyMess.dashboard.title}
                    </Typography>
                  {showStat()}
                    <img src={welcomeImage} />
                  </Box>                  
                  {showTrialMessage()}
                  {showInfoMessage()}
                </Route>
                <Route path="/main/kopapro/create" render={(props) => <LicenseEditForm key='new_license' {...props}></LicenseEditForm>} /> 
                <Route path="/main/kopapro/trial" render={(props) => <LicenseEditForm key='trial_license' {...props}></LicenseEditForm>} /> 
                {/* force to disable route */}
                { false && 
                  <Route path="/main/kopapro/edit/:code" render={(props) => <LicenseEditForm key='edit_license' {...props}></LicenseEditForm>} /> 
                }
                
                <Route path="/main/kopapro/extend/:code" render={(props) => <LicenseEditForm key='extend_license' {...props}></LicenseEditForm>} /> 
                <Route path="/main/kopapro/read/:code" render={(props) => <LicenseEditForm key='read_license' {...props}></LicenseEditForm>} /> 
                { user.type !== 'merchant' && <Route path="/main/merchant/create" render={(props) => <MerchantEditForm  key='create_merchant' {...props}></MerchantEditForm>} /> }
                { user.type !== 'merchant' && <Route path="/main/merchant/edit/:code" render={(props) => <MerchantEditForm  key='edit_merchant' {...props}></MerchantEditForm>} /> }
                { user.type !== 'merchant' && <Route path="/main/merchant/extend/:code" render={(props) => <MerchantEditForm  key='extend_merchant' {...props}></MerchantEditForm>} /> }
                
                { user.type !== 'merchant' &&  <Route exact path="/main/merchant" >
                    <MerchantList></MerchantList>
                </Route> }
                
                <Route exact path="/main/kopapro">
                  <KopaProLicense></KopaProLicense> 
                </Route>
                <Route path="/main/domains/create" render={(props) => <DomainsEditForm {...props} /> } /> 
                <Route exact path="/main/domains">
                  <Domains /> 
                </Route>                    
                
                <Route path="/main/account" render={(props) => <Account {...props} /> } />
                
            </Switch>            
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
}
